﻿import { SaopViewForm, SaopWfAction } from "../Core/saop-view-form";
import { global } from "../Common/saop-common";
import { SaopRegView } from "./saop-regUra-view";
import { SaopRegDetailsTableView } from "./saop-regUra-details-table-view";

export class SaopRegAttendanceAllEmployeesExcessHoursDetails extends SaopViewForm {
    private _formId: string;
    private _regUraView: SaopRegView;    
    private saopRegDetailsTableView: SaopRegDetailsTableView;
    //

    constructor(viewId: string, libName: string = "") {
        super(viewId, libName);
        this.fullScreen = true;
        this.addRecordEndpoint = "";
        this.editRecordEndpoint = "REGMonthEvents/GetRegMonthView";
        this.deleteRecordEndpoint = ""; 

        //
        this._regUraView = new SaopRegView(libName + "._regUraView");
        this.saopRegDetailsTableView = new SaopRegDetailsTableView(libName + ".saopRegDetailsTableView", "#reg-grid");
        //
        
    }

    private replaceParentNode(): void {
        let _viewModalBody = this.getViewModalBody();

        let _newRootElementHtml = `
            <div class="overflow-root" style="height:calc(100vh - 90px); overflow-y: auto;">
            </div>
        `;
        let _newRootElement = $(_newRootElementHtml);
        _newRootElement.append(_viewModalBody[0].innerHTML);

        _viewModalBody.empty();
        _viewModalBody.append(_newRootElement);
    }

    public viewShowComplete(sender: any, wfAction: SaopWfAction): void 
    {
        this.replaceParentNode();
        this._regUraView.refreshTableData(false);
        this.saopRegDetailsTableView.bindGridEvents();
    }    

}


